import { Typography, Row, Col, Card } from 'antd';
import React from 'react';
import {
    YoutubeFilled,
    CustomerServiceOutlined,
    SmileOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
const { Title, Text } = Typography;
const ShowVideo = () => {
    const navigate = useNavigate();
    return (
        <Row gutter={[32, 32]} justify="center">
            <Col span={24}>
                <Row gutter={[8, 32]}>
                    <Col span={24}>
                        <Row justify={"center"} >
                            <Col span={"auto"}>
                                <Title level={1}>活動影片</Title>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/_XwxV82SUpY?si=eOaD2vE-QNbpa_EQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/CrCqCTRfqHA?si=4KIkOmNGgBvy5rZd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/cXR9IuX49_0?si=4Y5Z_i7stbtu-RvI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/lmI5TE_1aWk?si=33H4AVaLi9qQkMZO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/ngYEsvgrJMo?si=B1Y6CsELE6704fXO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/FMhEzzlcga8?si=eRqeozp8_CA4xekd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/Vuo4bZOWZnY?si=Atk1zFHwZ2tMHcIs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/IYNCqfIseQ4?si=bFZXiMOQOSV6PIOf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <iframe width="100%" height="350" src="https://www.youtube.com/embed/CSI51-RFWU4?si=gqD6oNXgUUCf4vrm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                    <Col span={24}>
                        <Card
                            style={{
                                cursor: "pointer"
                            }} >
                            <Card.Grid
                                onClick={() => { window.open("https://www.youtube.com/channel/UCxwW57nnSQH1cnSXiHzWcrw") }}
                            >
                                <Row>
                                    <Col span={24}>
                                        <YoutubeFilled style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>訂閱 Youtube</Title>
                                        <Text >觀看更多朗讀節影片</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                            <Card.Grid onClick={() => { window.open("https://linktr.ee/poemlion") }}>
                                <Row>
                                    <Col span={24}>
                                        <CustomerServiceOutlined style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>聆聽 Podcast</Title>
                                        <Text > 收聽更多經典文學</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                            <Card.Grid onClick={() => { navigate("/poetry_reading") }}>
                                <Row>
                                    <Col span={24}>
                                        <SmileOutlined style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>前往詩詞朗讀</Title>
                                        <Text > 跟著音檔一起讀</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                        </Card>
                    </Col>
                </Row>
            </Col >
        </Row >
    )
};
export default ShowVideo;